var map = {
	"./asset-hyperlink.json": "./node_modules/@contentful/rich-text-types/dist/schemas/generated/asset-hyperlink.json",
	"./blockquote.json": "./node_modules/@contentful/rich-text-types/dist/schemas/generated/blockquote.json",
	"./document.json": "./node_modules/@contentful/rich-text-types/dist/schemas/generated/document.json",
	"./embedded-asset-block.json": "./node_modules/@contentful/rich-text-types/dist/schemas/generated/embedded-asset-block.json",
	"./embedded-entry-block.json": "./node_modules/@contentful/rich-text-types/dist/schemas/generated/embedded-entry-block.json",
	"./embedded-entry-inline.json": "./node_modules/@contentful/rich-text-types/dist/schemas/generated/embedded-entry-inline.json",
	"./embedded-resource-block.json": "./node_modules/@contentful/rich-text-types/dist/schemas/generated/embedded-resource-block.json",
	"./embedded-resource-inline.json": "./node_modules/@contentful/rich-text-types/dist/schemas/generated/embedded-resource-inline.json",
	"./entry-hyperlink.json": "./node_modules/@contentful/rich-text-types/dist/schemas/generated/entry-hyperlink.json",
	"./heading-1.json": "./node_modules/@contentful/rich-text-types/dist/schemas/generated/heading-1.json",
	"./heading-2.json": "./node_modules/@contentful/rich-text-types/dist/schemas/generated/heading-2.json",
	"./heading-3.json": "./node_modules/@contentful/rich-text-types/dist/schemas/generated/heading-3.json",
	"./heading-4.json": "./node_modules/@contentful/rich-text-types/dist/schemas/generated/heading-4.json",
	"./heading-5.json": "./node_modules/@contentful/rich-text-types/dist/schemas/generated/heading-5.json",
	"./heading-6.json": "./node_modules/@contentful/rich-text-types/dist/schemas/generated/heading-6.json",
	"./hr.json": "./node_modules/@contentful/rich-text-types/dist/schemas/generated/hr.json",
	"./hyperlink.json": "./node_modules/@contentful/rich-text-types/dist/schemas/generated/hyperlink.json",
	"./list-item.json": "./node_modules/@contentful/rich-text-types/dist/schemas/generated/list-item.json",
	"./ordered-list.json": "./node_modules/@contentful/rich-text-types/dist/schemas/generated/ordered-list.json",
	"./paragraph.json": "./node_modules/@contentful/rich-text-types/dist/schemas/generated/paragraph.json",
	"./resource-hyperlink.json": "./node_modules/@contentful/rich-text-types/dist/schemas/generated/resource-hyperlink.json",
	"./table-cell.json": "./node_modules/@contentful/rich-text-types/dist/schemas/generated/table-cell.json",
	"./table-header-cell.json": "./node_modules/@contentful/rich-text-types/dist/schemas/generated/table-header-cell.json",
	"./table-row.json": "./node_modules/@contentful/rich-text-types/dist/schemas/generated/table-row.json",
	"./table.json": "./node_modules/@contentful/rich-text-types/dist/schemas/generated/table.json",
	"./text.json": "./node_modules/@contentful/rich-text-types/dist/schemas/generated/text.json",
	"./unordered-list.json": "./node_modules/@contentful/rich-text-types/dist/schemas/generated/unordered-list.json"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./node_modules/@contentful/rich-text-types/dist/schemas/generated sync recursive ^\\.\\/.*\\.json$";